enum FilterMenuOption {
    Categories = 'Categories',
    Campuses = 'Campuses',
    Tags = 'Tags',
}

export default FilterMenuOption;
